// extracted by mini-css-extract-plugin
export default {"screenContainer":"FJBZvzT_Gg3Rqb6E1tEZ","inputsContainer":"JObVbpaswmmg8wo_lhqw","widgetInputsContainer":"pomQoDibxPmEBbh8WQhp","skipSpeedButton":"VVDYD2BEoIzZ2UeMN6Re"};